const calculateVirtualSwitchActionType = (stateDescription, actionDelay, actionDuration) => (
  Object.keys(actionDelay).length || Object.keys(actionDuration).length ? 'VirtualSwitchDelayDuration' : 'VirtualSwitch'
)

export default calculateVirtualSwitchActionType
